import React from "react"
import _reduce from "lodash/reduce"

import type { DeepPartial } from "@src/entities"
import type { Order } from "@src/entities/types/api"

export interface AccountOrdersProps {
  orders: DeepPartial<Order>[]
}
export default function AccountOrders({ orders }: AccountOrdersProps) {
  const formatCount = (count: number) => {
    if (count === 0) {
      return ""
    }
    if (count === 1) {
      return "1 item on"
    }
    return `${count} items on`
  }

  const formatDate = (date: Date) => {
    // const dateDate = new Date(date)
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(date)
  }

  return (
    <section className="mb-8">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xl font-extrabold">My Past Orders</h3>
      </div>
      <div>
        {orders.length > 0 && (
          <p className="mb-4">Below are your recent orders.</p>
        )}
        <div className="divide-y">
          {orders.map((order) => (
            <div
              className="flex items-start justify-between py-2"
              key={order.id}
            >
              <div>
                <h4 className="font-browser font-medium text-lg">
                  {formatCount(
                    _reduce(
                      order.lineItems,
                      (sum, item) => sum + item?.quantity ?? 0,
                      0
                    )
                  )}{" "}
                  {formatDate(new Date(order.createdAt))}
                </h4>
                <p className="italic text-sm">
                  {order.paidWith && `Paid with ${order.paidWith}`}
                </p>
              </div>
              <p className="text-sm">{order.id && `Order id ${order.id}`}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
